(ns manage.export-ocp.view
  (:require ["@mui/material/Autocomplete$default" :as Autocomplete]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Checkbox$default" :as Checkbox]
            ["@mui/material/FormControlLabel$default" :as FormControlLabel]
            ["@mui/material/TextField$default" :as TextField]
            ["react-use/lib/useDebounce$default" :as useDebounce]
            [common.flags :refer [use-flag]]
            [common.ocp.view :refer [defocp ocp]]
            [common.resource.query.adserver :as adserver.q]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [manage.export-ocp.db :as form]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui form-field-target-build []
  (let [options (adserver.q/use-adservers-options)]
    ($ form-field
       {:label "Adserver"}
       (r/as-element
        [dropdown (merge (form/use-bind-control [:adserverId])
                         {:options options})]))))

(defui form-field-target-name []
  (let [data (use-subscribe [:resource.adset/one])
        [name set-name] (uix/use-state (get-in data [:value :name]))]
    ($ form-field
       {:label "Export name"}
       ($ input (let [{on-change :on-change :as bind-control} (form/use-bind-control [:exportName]
                                                                                     {:on-change-event :form.adset-export/set-export-name})]
                  (merge
                   bind-control
                   {:value name
                    :on-change (fn [event]
                                 (set-name (-> event .-target .-value))
                                 (on-change event))}))))))

(defui form-field-target-export []
  (let [options (form/use-target-export-options)]
    ($ form-field
       {:label "Adserver seat"}
       (r/as-element
        [dropdown (merge (form/use-bind-control [:adserveraccountconfigurationId])
                         {:options options})]))))

(defui form-field-adform-campaigns []
  (let [[input-value set-input-value] (uix/use-state "")
        [value set-value] (uix/use-state nil)
        adserver-account-configuration-id (use-subscribe [:form.adset-export/value [:adserveraccountconfigurationId]])
        options (use-subscribe [:form.adset-export/adform-campaign-list])
        status (use-subscribe [:form.adset-export/adform-campaign-status])
        placeholder (cond (= status :pending) "Loading campaigns"
                          (empty? options) "No campaigns found"
                          :else "")]
    (useDebounce (fn []
                   (rf/dispatch [:form.adset-export/get-adform-campaigns adserver-account-configuration-id input-value]))
                 500
                 #js [adserver-account-configuration-id input-value])
    ($ form-field
       {:label "Adform campaigns"}
       ($ Autocomplete
          {:size "small"
           :value value
           :onChange (fn [_ value]
                       (set-value value)
                       (rf/dispatch [:form.adset-export/on-change [:adformCampaignId] (:value value)]))
           :options (to-array options)
           :filterOptions identity
           :renderInput (fn [^js props]
                          ($ TextField (js/Object.assign props #js {:placeholder placeholder})))
           :onInputChange (fn [^js _event ^js new-input-value]
                            (set-input-value new-input-value))
           :getOptionLabel (fn [option]
                             (:label option))
           :renderOption (fn [props option state]
                           ($ :div (js/Object.assign props #js {:key (.-index state)})
                              (:label option)))}))))

(defui body []
  (let [buildTarget (use-subscribe [:form.adset-export/value [:adserverId]])
        config-id (use-subscribe [:form.adset-export/value [:adserveraccountconfigurationId]])
        is-adform? (use-subscribe [:form.adset-export/is-adform?])
        is-google-cm? (use-subscribe [:form.adset-export/is-cm-360?])
        extra-param-checked (use-subscribe [:form.adset-export/value [:extraQuery]])
        tdd-support-enabled? (use-flag :support-the-trade-desk-extra-query)]
    ($ :<>
       ($ form-field-target-build)
       ($ form-field-target-name)
       (when buildTarget
         ($ form-field-target-export))
       (when (and is-adform? config-id)
         ($ form-field-adform-campaigns))
       (when (and is-google-cm? tdd-support-enabled?)
         ($ FormControlLabel
            {:label "The TradeDesk support"
             :control ($ Checkbox {:checked (or extra-param-checked false)
                                   :onChange #(rf/dispatch [:form.adset-export/on-change
                                                            [:extraQuery] (-> % .-target .-checked)])})})))))

(defui footer []
  (let [build-target (use-subscribe [:form.adset-export/value [:adserverId]])
        adform-export-ready? (use-subscribe [:form.adset-export/adform-export-target])]
    ($ :<>
       ($ Button {:disabled (not build-target)
                  :on-click #(rf/dispatch [:form.adset-export/submit :manual])
                  :variant "outlined"}
          "Build .zip(s)")
       ($ Button {:disabled (not adform-export-ready?)
                  :on-click #(rf/dispatch [:form.adset-export/submit :direct])
                  :variant "contained"}
          "Build and Export"))))

(defocp adset-export-ocp :adset/export []
  (uix/use-effect (fn []
                    (rf/dispatch [:form.adset-export/init])
                    (fn []
                      (rf/dispatch [:form.adset-export/destroy])))
                  [])
  ($ ocp
     (merge {:title "Export your Adset"
             :on-submit #(rf/dispatch [:form.adset-export/submit :manual])
             :footer ($ footer)})
     ($ body)))
